'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileAttachmentIdsInMessage = undefined;

var _immutable = require('immutable');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _getLiveChatAttachments = require('../../pubnub-message/operators/getLiveChatAttachments');

var _attachmentTypes = require('../../common-message-format/constants/attachmentTypes');

var _fileAttachmentGetters = require('../../common-message-format/operators/fileAttachmentGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * @param {PubNubMessageRecord} message - pubnub message record
 * @returns {List<number>} list of file attachment ids in message
 *
 */
var fileAttachmentIdsInMessage = exports.fileAttachmentIdsInMessage = function fileAttachmentIdsInMessage(message) {
  var attachments = (0, _getLiveChatAttachments.getLiveChatAttachments)(message) || (0, _immutable.List)();

  var fileAttachment = attachments.find(function (attachment) {
    return (0, _get2.default)(_messageTypes.MESSAGE_TYPE_ID, attachment) === _attachmentTypes.FILES;
  });

  if (!fileAttachment) {
    return (0, _immutable.List)();
  }

  return (0, _fileAttachmentGetters.getFileIds)(fileAttachment);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/fileAttachmentIdsInMessage.js
// module id = 160
// module chunks = 2 3